import type { PromptInputMessage } from '@crowdex/ui/ai/prompt-input';
import { createContext, type ReactNode, useContext } from 'react';

export const PluginConversationComposerContext = createContext<{
  participants: readonly {
    id: string;
    name: string;
    agentId: string;
    avatar?: string;
    /** Its mark in the @ list, when the conversation draws its own (a project's personas). */
    icon?: ReactNode;
  }[];
  allowEveryone?: boolean;
  /** The conversation is a group by nature (a group of personas): it cannot leave team mode. */
  fixed?: boolean;
  placeholder?: string;
  recipientControl: ReactNode;
  replyControl: ReactNode;
  ready: boolean;
  pending: boolean;
  send(message: PromptInputMessage): Promise<void>;
} | null>(null);

export const usePluginConversationComposer = () => useContext(PluginConversationComposerContext);
